import { createSlice } from "@reduxjs/toolkit";
import { liveAlarmColumns } from "../../Components/AddElementPanel2/config/alarms.config";

const initialState = {
  locks: { dashboards: {} },
  commandButtons: {
    touchMode: false,
  },
  visibility: {
    widgets: {},
    sections: {},
    reloadButton: false,
    alarmNotification: {
      rows: liveAlarmColumns,
      ship: null,
      plcs: null,
      actionButtons: true,
      visible: false,
    },

    alarmconfig: { tanks: false, infoContainer: false },
    adminLogin: true,
    adminLogoutMinutes: 30,
    navbarKpis: [],
    navbarButtons: [],
    navbarFillBar: { sensor: null },
    navbarUtcClock: false,
  },
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    toggleWidget(state, action) {
      const key = action.payload;
      const prev = state.visibility.widgets[key]?.visible;
      state.visibility.widgets[key] = { visible: !(prev ?? true) };
    },
    toggleSection(state, action) {
      const key = action.payload;
      const prev = state.visibility.sections[key]?.visible;
      state.visibility.sections[key] = { visible: !(prev ?? true) };
    },
    setWidgetsVisibility(state, action) {
      state.visibility.widgets = action.payload;
    },
    setAlarmNotification(state, action) {
      state.visibility.alarmNotification = {
        ...state.visibility.alarmNotification,
        ...action.payload,
      };
    },
    setSectionsVisibility(state, action) {
      state.visibility.sections = action.payload;
    },
    setAllSettings(state, action) {
      const incomingVisibility = action.payload.visibility ?? {};
      let navbarKpis = incomingVisibility.navbarKpis;
      if (!navbarKpis && incomingVisibility.navbarKpi) {
        navbarKpis = [{ id: "migrated", ...incomingVisibility.navbarKpi }];
      }
      return {
        ...state,
        ...action.payload,
        visibility: {
          ...state.visibility,
          ...incomingVisibility,
          navbarKpis: navbarKpis ?? state.visibility.navbarKpis,
          alarmNotification: {
            ...state.visibility.alarmNotification,
            ...(incomingVisibility.alarmNotification ?? {}),
          },
        },
      };
    },
  },
});

export const {
  toggleWidget,
  toggleSection,
  setWidgetsVisibility,
  setSectionsVisibility,
  setAlarmNotification,
  setAllSettings,
} = settingsSlice.actions;
export default settingsSlice.reducer;
